export default __webpack_public_path__ + "140 Jahre Cashback-Aktion 2026 -Anbieter_FINAL.pdf";